var render = function render(){
  var _vm$summaryData$zames, _vm$summaryData$zames2, _vm$summaryData$zames3, _vm$summaryData$zames4, _vm$summaryData$zames5, _vm$summaryData$zames6, _vm$summaryData$zames7, _vm$summaryData$zames8, _vm$summaryData$zames9, _vm$summaryData;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "d-flex justify-content-between align-center"
  }, [_c('div', [_vm._v(" Príjem "), _c('span', {
    staticClass: "pop-800"
  }, [_vm._v(_vm._s(_vm.summaryData.clientInfo.type.toLowerCase()) + "a")]), _vm._v(" zo "), _c('span', {
    staticClass: "pop-800"
  }, [_vm._v("zamestnania")])]), _c('div', [_c('img', {
    staticClass: "activate-button nav-link-icon filter-primary",
    "class": {
      'rotate': _vm.opened
    },
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f28_icons8-collapse-arrow.svg",
      "alt": ""
    },
    on: {
      "click": function click($event) {
        _vm.opened = !_vm.opened;
      }
    }
  })])]), _c('v-expand-transition', {
    staticClass: "summary-items-transition"
  }, [_vm.opened ? _c('div', {
    staticClass: "summary-items-wrapper"
  }, [_c('text-value-holder', {
    attrs: {
      "label": 'typ príjmu',
      "value": _vm.summaryData.typ
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'druh príjmu',
      "value": 'Zamestnanie'
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'mesačný príjem',
      "value": _vm.summaryData.dti.extra.prijem_mo
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'diety mesačn. príjem',
      "value": _vm.monthlyDiets
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'zamestnávateľ',
      "value": (_vm$summaryData$zames = _vm.summaryData.zamestnavatel) === null || _vm$summaryData$zames === void 0 ? void 0 : _vm$summaryData$zames.name
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'ičo',
      "value": (_vm$summaryData$zames2 = _vm.summaryData.zamestnavatel) === null || _vm$summaryData$zames2 === void 0 ? void 0 : _vm$summaryData$zames2.ico
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'obec',
      "value": (_vm$summaryData$zames3 = _vm.summaryData.zamestnavatel) === null || _vm$summaryData$zames3 === void 0 ? void 0 : _vm$summaryData$zames3.address_city
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'ulica',
      "value": (_vm$summaryData$zames4 = _vm.summaryData.zamestnavatel) === null || _vm$summaryData$zames4 === void 0 ? void 0 : _vm$summaryData$zames4.address_street
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'súpisné číslo',
      "value": (_vm$summaryData$zames5 = _vm.summaryData.zamestnavatel) === null || _vm$summaryData$zames5 === void 0 ? void 0 : _vm$summaryData$zames5.address_popisne
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'orientačné číslo',
      "value": (_vm$summaryData$zames6 = _vm.summaryData.zamestnavatel) === null || _vm$summaryData$zames6 === void 0 ? void 0 : _vm$summaryData$zames6.address_number
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'PSČ',
      "value": (_vm$summaryData$zames7 = _vm.summaryData.zamestnavatel) === null || _vm$summaryData$zames7 === void 0 ? void 0 : _vm$summaryData$zames7.address_zip
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'email. zamestn',
      "value": (_vm$summaryData$zames8 = _vm.summaryData.zamestnavatel) === null || _vm$summaryData$zames8 === void 0 ? void 0 : _vm$summaryData$zames8.email
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'telefon zamestn',
      "value": (_vm$summaryData$zames9 = _vm.summaryData.zamestnavatel) === null || _vm$summaryData$zames9 === void 0 ? void 0 : _vm$summaryData$zames9.telefon
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'prac. pomer na dobu',
      "value": (_vm$summaryData = _vm.summaryData) === null || _vm$summaryData === void 0 ? void 0 : _vm$summaryData.employment_type
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'zamestnaný od',
      "value": _vm.employmentStartDisplay
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'zamestnaný do',
      "value": _vm.transformDate(_vm.summaryData.zamestnanie_do)
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'skúšobná/výpovedn. doba',
      "value": _vm.summaryData.vypovedna_skusobna_doba
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'profesia',
      "value": _vm.$store.getters['formStore/getProfessionLabelById'](_vm.summaryData.profesia)
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'zaradenie',
      "value": _vm.summaryData.pracovne_zaradenie
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'odvetvie',
      "value": _vm.summaryData.zamestnavatel_odvetvie
    }
  })], 1) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }